import { Stack, Typography } from "@mui/material";
import { GradingBlock } from "./GradingBlock";
import { FeedbackScores } from "../../../../types/apiTypes";

const FIELDS = [
  {
    field: "impression_score",
    title: "What is your overall impression of the platform?",
  },
  {
    field: "accuracy_score",
    title:
      "How would you rate the accuracy of the analysis provided by the system?",
  },
  {
    field: "business_flows_score",
    title:
      "How well does the system support your business or operational flows?",
  },
  {
    field: "expectations_score",
    title: "How well does the system support the features you expect?",
  },
];

export const GradeBlock = ({
  gradeData,
  setGradeData,
}: {
  gradeData: FeedbackScores;
  setGradeData: (data: FeedbackScores) => void;
  nextStepHandler: () => void;
}) => {
  const onGradeChange = (grade: number | null, key: string) => {
    setGradeData({ ...gradeData, [key]: grade });
  };

  return (
    <Stack gap="24px" paddingBottom="16px">
      <Typography component="span" variant="body1" color="text.secondary">
        1 - Unsuitable for use, 5 - Exceeds expectations
      </Typography>

      {FIELDS.map(({ field, title }) => (
        <GradingBlock
          key={field}
          value={gradeData[field as keyof FeedbackScores]}
          title={title}
          onChange={onGradeChange}
          field={field}
        />
      ))}
    </Stack>
  );
};
